import "./sharing-referral.scss";

const SharingLayout = ({ children }) => {
  return children;
};

SharingLayout.propTypes = {};

export default SharingLayout;
